import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface CutomerBookingTableProps {
  isPast?: boolean;
}

const CutomerBookingTable = ({ isPast }: CutomerBookingTableProps) => {
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);

  const rows = [
    {
      id: 1,
      clientName: "John",
      phone: "+91 9876543210",
      bookingId: "#101",
      Guests: "04",
      Status: "New",
      Name: "Abdullah",
      userType: "Paid",
      amount: "AED 200",
    },
    {
      id: 2,
      clientName: "Priya",
      phone: "+91 9876512345",
      bookingId: "#102",
      Guests: "02",
      Status: "Confirmed",
      Name: "Sara",
      userType: "App",
    },
    {
      id: 3,
      clientName: "Aman",
      phone: "+91 9988776655",
      bookingId: "#103",
      Guests: "03",
      Status: "Cancelled",
      Name: "Zaid",
      userType: "Link",
      amount: "AED 150",
    },
    {
      id: 4,
      clientName: "Ravi",
      phone: "+91 9123456780",
      bookingId: "#104",
      Guests: "01",
      Status: "New",
      Name: "Aisha",
      userType: "App",
      amount: "AED 100",
    },
    {
      id: 5,
      clientName: "Sneha",
      phone: "+91 9090909090",
      bookingId: "#105",
      Guests: "02",
      Status: "Confirmed",
      Name: "Ahmed",
      userType: "Complimentary",
    },
  ];

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };

  const [Employee, setEmployee] = useState("0");
  const [Status, setStatus] = useState("0");
  const [assignToMe, setAssignToMe] = useState(true);
  const [assignToEmployee, setAssignToEmployee] = useState(false);
  const navigate = useNavigate();

  const handleChange1 = (event: SelectChangeEvent) => {
    setEmployee(event.target.value as string);
  };

  const handleChange2 = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  return (
    <div className="table_container">
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Booking ID</th>
            <th>Client Name</th>
            <th>Guests</th>
            <th>Internal Status</th>
            <th>Employee Name</th>
            <th>User Type</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <React.Fragment key={row.id}>
              <tr>
                <td>{row.bookingId}</td>
                <td>
                  <div>
                    <div>{row.clientName}</div>
                    <div style={{ fontSize: "12px", color: "#888" }}>
                      {row.phone}
                    </div>
                  </div>
                </td>
                <td>{row.Guests}</td>
                <td>{row.Status}</td>
                <td>{row.Name}</td>
                <td>{row.userType}</td>
                <td>
                  {(row.userType === "Paid" || row.userType === "Link") &&
                  row.amount
                    ? row.amount
                    : "-"}
                </td>
              </tr>

              {!isPast && expandedRowId === row.id && (
                <tr>
                  <td colSpan={7}>
                    <div className="expanded-content">
                      <div className="form_flex booking_assign">
                        <div className="w_100">
                          <div className="control_group charge_field">
                            <h2>Assign To</h2>
                          </div>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={assignToMe}
                                  onChange={(e) => {
                                    setAssignToMe(e.target.checked);
                                    if (e.target.checked)
                                      setAssignToEmployee(false);
                                  }}
                                />
                              }
                              label="Me"
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={assignToEmployee}
                                  onChange={(e) => {
                                    setAssignToEmployee(e.target.checked);
                                    if (e.target.checked) setAssignToMe(false);
                                  }}
                                />
                              }
                              label="Employee"
                            />
                          </FormGroup>

                          {assignToEmployee && (
                            <Select value={Employee} onChange={handleChange1}>
                              <MenuItem value="0" disabled>
                                Employee Listing
                              </MenuItem>
                              <MenuItem value="10">Employee 1</MenuItem>
                              <MenuItem value="20">Employee 2</MenuItem>
                              <MenuItem value="30">Employee 3</MenuItem>
                            </Select>
                          )}

                          <Select value={Status} onChange={handleChange2}>
                            <MenuItem value="0" disabled>
                              Status
                            </MenuItem>
                            <MenuItem value="10">Status 1</MenuItem>
                            <MenuItem value="20">Status 2</MenuItem>
                            <MenuItem value="30">Status 3</MenuItem>
                          </Select>

                          <Button className="btn btn_primary">Save</Button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CutomerBookingTable;
